{
  "version": 1,
  "asset_id": "6bc3e00c-baaa-4eb8-89b7-f9bc7d08bfe1",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/6bc3e00c-baaa-4eb8-89b7-f9bc7d08bfe1/gallery-6.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/6bc3e00c-baaa-4eb8-89b7-f9bc7d08bfe1/gallery-6.jpeg",
  "original_filename": "gallery-6.jpeg",
  "size": 555288,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:37Z"
}
